import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { useGetCsrfCookieQuery } from "api/Sanctum/hooks.ts";
import { TFunction } from "i18next";
import { useEffect } from "react";

interface RootRouteCtx {
    t: TFunction;
}

export const Route = createRootRouteWithContext<RootRouteCtx>()({
    component: RootComponent,
});

function RootComponent() {
    const getCsrfCookieQuery = useGetCsrfCookieQuery();

    useEffect(() => {
        getCsrfCookieQuery.refetch();
    }, []);

    return (
        <>
            <Outlet />
        </>
    );
}
